<template>
  <header class="sticky-header">
    <subscriber-header-top-vue v-if="0 === subscriberId"></subscriber-header-top-vue>
    <header-top-vue v-else />
    <header-bottom-vue
            :additional="additional"
            :heading="''"
            :specific-link="'MailDetail'"
            :back-button="backButton"
    />
  </header>
</template>

<script>
  import { mapGetters } from "vuex";
  import HeaderTopVue from "../../common/HeaderTop.vue";
  import HeaderBottomVue from "../../common/HeaderBottom";
  import SubscriberHeaderTopVue from '../SubscriberHeaderTop.vue';

  export default {
    props: {
      addNew: Boolean,
      hideNew: Function
    },
    computed: {
      ...mapGetters({
        previousRoute: "getPreviousRoute"
      }),
      ...mapGetters("portalemail", {
        subscriberId: "getSubscriberId"
      }),
      additional() {
        return {
          click: null
        };
      },
      backButton() {
        return {
          show: true,
          action: () => {
            // this.$router.go(-1);
            if (!("previousRoute" in this) || this.previousRoute === "/") {
              this.$router.push("/daily");
            } else {
              this.$router.go(-1);
            }
          }
        };
      }
    },
    components: {
      HeaderTopVue,
      HeaderBottomVue,
      SubscriberHeaderTopVue
    }
  };
</script>

<style scoped>
  header >>> .year-wrapper {
    position: absolute;
    left: 50%;
    top: 10px;
    transform: translateX(-50%);
    line-height: 18px;
  }

  @media (max-width: 450px) {
    header >>> .year-wrapper span {
      font-size: 18px !important;
    }
  }
</style>
